import { AppDispatch, RootState } from "./store";
import merchant_services from "services/merchant_services";
import { cacheCardNumber } from "./userSlice";
import { networkTypeSelector } from "./userSliceHelpers";

export const fetchCardNumber =
  (address: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const existing = getState().user.cardNumberMap[address];
    if (existing) return;

    // Not a hook, so no useSelector — but a thunk gets getState, which is the
    // same source the hooks read through networkTypeSelector.
    const networkType = networkTypeSelector(getState());

    try {
      const cardNumber = await merchant_services.getCardNumberFromAddress(
        address,
        networkType,
      );
      if (cardNumber) {
        dispatch(cacheCardNumber({ address, cardNumber }));
      }
    } catch (error) {
      // need fix after error handle todo
      console.log("fetchCardNumber error:", error);
      const cardNumber = "External account";
      dispatch(cacheCardNumber({ address, cardNumber }));
    }
  };
